import { render, staticRenderFns } from "./EspecialidadeFormulario.vue?vue&type=template&id=32d860bc"
import script from "./EspecialidadeFormulario.vue?vue&type=script&lang=js"
export * from "./EspecialidadeFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports